<template>
    <div>
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">
                    <reports></reports>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Reports from './astral-import/Reports';

    export default {

        components: {
            Reports
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('common.astral-import'),
                    },
                ]
            }
        },
    }
</script>
